import { useEffect, useState } from "react";
import { convertSecondsToMinutesSeconds } from "../utils/Utils";
import MultiEventsDiagram from "./MultiEventsDiagram";

function MultiEventsList({ match, team, events, onSelectEvent }) {
  const [searchText, setSearchText] = useState("");
  const [filteredEvents, setFilteredEvents] = useState(events);
  const [showCodes, setShowCodes] = useState(false);
  const [showChain, setShowChain] = useState(false);
  const [codeteam, setCodeTeam] = useState(team);
  const [chainEvents, setChainEvents] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(null);

  const doSelectEvent = (e) => {
    setSelectedEvent(e);
    onSelectEvent(e);
  };

  useEffect(() => {
    console.log(events);
  }, [events, selectedEvent]);

  const showEvents = () => {
    return (
      <>
        <div className="flex-col h-[32vh] overflow-auto mt-1 shadow-lg bg-base-200/80">
          <ul className="flex flex-col gap-1">
            {events &&
              events.map((e, idx) => (
                <li
                  key={idx}
                  className={
                    idx % 2 !== 0
                      ? "px-1 py-0.5 cursor-pointer"
                      : "px-1 py-0.5 bg-base-300/50 cursor-pointer"
                  }
                  onClick={() => {
                    doSelectEvent(e);
                  }}
                >
                  <div className={selectedEvent === e ? "flex-col bg-primary/50" : "flex-col"}>
                    <div className="flex justify-between">
                      <div className="font-bold">{e["FULLNAME"]}</div>
                    </div>
                    <div className="flex justify-between">
                      <div className="text-xs">{e["STATISTIC_CODE"]}</div>
                      <div className="text-left">
                        {convertSecondsToMinutesSeconds(e["PERIOD_SECS"])}
                      </div>
                      {/* <div>
                        {e["distance"] && parseFloat(e["distance"]).toFixed(2)}m
                      </div> */}
                      {/* <div>{e["STATISTIC_CODE"]}</div> */}
                    </div>
                  </div>
                </li>
              ))}
          </ul>
        </div>

        {/* <div className="flex-col">
          {events.map((e, idx) => (
            <div key={idx}>
              <p>{e["FULLNAME"]}</p>
              <p>{convertSecondsToMinutesSeconds(e["PERIOD_SECS"])}</p>
              <p>{e["STATISTIC_CODE"]}</p>
            </div>
          ))}
        </div> */}
      </>
    );
  };

  return (
    <>
      <div className="flex gap-1">
        <MultiEventsDiagram
          panelSize={{ width: 200, height: 300 }}
          groundSize={{
            width: match.venueWidth,
            height: match.venueLength,
          }}
          events={events}
          selectedEvent={selectedEvent}
          onSelectEvent={(ev) => doSelectEvent(ev)}
        />
        {showEvents()}
      </div>
    </>
  );
}

export default MultiEventsList;
